import React, { useEffect, useState, useRef } from 'react';
import storage from 'utils/storage';
import { VerificationCodeInputField } from 'components/Form';
import { RefreshCcw } from 'lucide-react';
import { Button, Text } from 'components/Elements';
import { loginWithEmailOTP } from '../api/emailOTPLogin';
import { verifyEmailOTPLogin } from '../api/verifyEmailOTPLogin';
import { REMOTE_URLS } from 'config/remotes';
import Cookies from 'js-cookie';
import { generateDeepLink, parseDeepLink } from 'react-deep-link';

const parsedData = parseDeepLink(new URLSearchParams(window.location.search));

export const EmailOTPForm = ({ onSuccess }) => {
  const [verificationCode, setVerificationCode] = useState();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [verifying, setVerifying] = useState(false);
  const [success, setSuccess] = useState(false);
  const [sendingOTP, setSendingOTP] = useState(false);

  const cookieData = Cookies.get('loginData');

  const parsedCookieData = JSON.parse(cookieData);

  const otpSentRef = useRef(false); // Prevent multiple calls

  useEffect(() => {
    if (otpSentRef.current) return; // If already sent, prevent re-execution
    otpSentRef.current = true;

    const sendEmailOTP = async () => {
      setSendingOTP(true);
      try {
        const result = await loginWithEmailOTP({
          email: parsedCookieData.user,
        });
        console.log(result);
      } catch (err) {
        console.error('Failed to send OTP:', err);
        setError('Failed to send OTP. Please try again.');
      } finally {
        setSendingOTP(false);
      }
    };

    sendEmailOTP();
  }, []);

  const handleVerify = async () => {
    setVerifying(true);
    setError('');
    const data = {
      email: parsedCookieData.user,
      code: verificationCode,
    };
    try {
      const response = await verifyEmailOTPLogin(data);
      setSuccess(true);
      const authorizeDomainKey = Cookies.get('authorizeDomainKey');

      const authorizeDomain = REMOTE_URLS[authorizeDomainKey];

      if (authorizeDomain) {
        Cookies.remove('token');

        const url = generateDeepLink({
          baseUrl: authorizeDomain,
          route: parsedCookieData.redirectPath,
          state: {
            token: response.user?.token,
            redirectPath: parsedCookieData.redirectPath,
            app: authorizeDomainKey,
            ...parsedCookieData,
          },
        });

        window.location.href = url;
      }
    } catch (err) {
      console.log(err);
      setError('Invalid verification code. Please try again.');
    } finally {
      setVerifying(false);
    }
  };

  return (
    <div className="">
      <div className="mt-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Provide the 6-digit code that has been sent to your email,{' '}
          {parsedCookieData.user} to verify login
        </label>
        <div className="flex space-x-2 justify-center">
          <VerificationCodeInputField
            length={6}
            onChange={(code) => setVerificationCode(code)}
          />
        </div>
      </div>
      {success && (
        <p className="text-green-500 text-center mt-3">
          Verification successful!
        </p>
      )}
      {error && (
        <>
          <p className="text-red-500 text-center mt-3">{error}</p>
          <button className="flex flex-row items-center space-x-2">
            <RefreshCcw size={12} />
            <Text>Try again</Text>
          </button>
        </>
      )}
      <div className="w-full my-8">
        <Button
          className="w-full"
          onClick={handleVerify}
          disabled={verifying || verificationCode === 6}
        >
          {verifying ? 'Verifying...' : 'Verify'}
        </Button>
      </div>
    </div>
  );
};
